import { AxiosResponse } from 'axios';
import { SET_ZMANIM_DISPLAY_OVERRIDES_N, SET_ZMANIM_DISPLAY_OVERRIDE_N, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_ZMANIM_DISPLAY_OVERRIDE_N_ISLOADING,
  DELETE_ZMANIM_DISPLAY_OVERRIDE_N,
  EDIT_ZMANIM_DISPLAY_OVERRIDE_N,
  GET_ZMANIM_DISPLAY_OVERRIDE_N,
  GET_ZMANIM_DISPLAY_OVERRIDES_N,
  REGISTER_ZMANIM_DISPLAY_OVERRIDE_N,
  TOGGLE_ZMANIM_DISPLAY_OVERRIDE_N_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import ZmanimDisplayOverride_N from '@/services/zmanim_display_override_N';
import { Module } from 'vuex';
import { EditZmanimDisplayOverride_N, RegisterZmanimDisplayOverride_N, GetZmanimDisplayOverride_N } from '@/dtos/zmanim_display_override_N.dto';

const zmanimDisplayOverride_N: Module<any, {}> = {
  state: {
    zmanimDisplayOverride_N: {
      data: null,
      isLoading: false,
    },
    zmanimDisplayOverrides_N: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    zmanimDisplayOverride_N: (state: { zmanimDisplayOverride_N: any }) => state.zmanimDisplayOverride_N,
    zmanimDisplayOverrides_N: (state: { zmanimDisplayOverrides_N: any }) => state.zmanimDisplayOverrides_N,
  },
  mutations: {
    [SET_ZMANIM_DISPLAY_OVERRIDE_N]: (
      state: { zmanimDisplayOverride_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.zmanimDisplayOverride_N.data = payload.data) : null;
      state.zmanimDisplayOverride_N.isLoading = payload.isLoading;
    },
    [SET_ZMANIM_DISPLAY_OVERRIDES_N]: (
      state: { zmanimDisplayOverrides_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.zmanimDisplayOverrides_N.data = payload.data) : null;
      state.zmanimDisplayOverrides_N.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_ZMANIM_DISPLAY_OVERRIDE_N]: async ({ commit }: any, payload: RegisterZmanimDisplayOverride_N) => {
      commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: true });

      const result: AxiosResponse = await ZmanimDisplayOverride_N.registerZmanimDisplayOverride_N(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { isLoading: false });
        return false;
      }
    },
    [GET_ZMANIM_DISPLAY_OVERRIDES_N]: async ({ commit }: any, payload: any) => {
      commit(SET_ZMANIM_DISPLAY_OVERRIDES_N, { data: null, isLoading: true });

      const result: AxiosResponse = await ZmanimDisplayOverride_N.getZmanimDisplayOverrides_N(
        payload as GetZmanimDisplayOverride_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_DISPLAY_OVERRIDES_N, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_ZMANIM_DISPLAY_OVERRIDES_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_DISPLAY_OVERRIDES_N, { isLoading: false });
        return false;
      }
    },
    [GET_ZMANIM_DISPLAY_OVERRIDE_N]: async ({ commit }: any, payload: any) => {
      commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: true });

      const result: AxiosResponse = await ZmanimDisplayOverride_N.getZmanimDisplayOverrides_N(
        payload as GetZmanimDisplayOverride_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, {
            data: result.data.data?.[0] ?? null,
            isLoading: false,
          });
          return result.data.data?.[0];
        }
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { isLoading: false });
        return false;
      }
    },
    [EDIT_ZMANIM_DISPLAY_OVERRIDE_N]: async ({ commit }: any, payload: EditZmanimDisplayOverride_N) => {
      commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: true });

      const result: AxiosResponse = await ZmanimDisplayOverride_N.editZmanimDisplayOverride_N(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_ZMANIM_DISPLAY_OVERRIDE_N_IS_ACTIVE]: async ({ commit, state }: any, payload: { id: string }) => {
      commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await ZmanimDisplayOverride_N.toggleZmanimDisplayOverride_NIsActive(payload);

      if (result) {
        if (result.data.status) {
          let index: number | null = null;
          if (state.zmanimDisplayOverrides_N?.data && Array.isArray(state.zmanimDisplayOverrides_N.data)) {
            state.zmanimDisplayOverrides_N.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null) {
              state.zmanimDisplayOverrides_N.data[index].isActive = result.data.data.isActive;
            }
          }
          commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { isLoading: false });
        return false;
      }
    },
    [DELETE_ZMANIM_DISPLAY_OVERRIDE_N]: async ({ commit }: any, payload: string) => {
      commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: true });

      const result: AxiosResponse = await ZmanimDisplayOverride_N.deleteZmanimDisplayOverride_N(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ZMANIM_DISPLAY_OVERRIDE_N_ISLOADING]: ({ commit }) => {
      commit(SET_ZMANIM_DISPLAY_OVERRIDE_N, { isLoading: false });
      commit(SET_ZMANIM_DISPLAY_OVERRIDES_N, { isLoading: false });
    },
  },
};

export default zmanimDisplayOverride_N;
